export default __webpack_public_path__ + "static/media/group_therapy.57d04039.png";